import React, { FC } from 'react';

interface TopDivisionsProps {
  divisions?: [string, string, number][] | null;
}

const fmt = (n: number) => `$${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 })}`;

const TopDivisions: FC<TopDivisionsProps> = ({ divisions }) => {
  const list = divisions?.slice(0, 5) ?? [];
  const maxAmount = list.length > 0 ? Math.max(...list.map(d => Number(d[2])), 1) : 1;

  return (
    <div className="bg-white rounded-3 shadow-sm p-4 h-100" style={{ border: '1px solid #f0f0f0' }}>
      <h6 className="fw-bold mb-3" style={{ color: '#1a1a2e', fontSize: 12, textTransform: 'uppercase', letterSpacing: '0.06em' }}>
        Top Teams
      </h6>
      {list.length === 0 ? (
        <p className="text-muted small text-center py-3 mb-0">No division data yet</p>
      ) : (
        <div className="d-flex flex-column gap-3">
          {list.map(([divName, primaryName, amount], idx) => {
            const barPct = Math.round((Number(amount) / maxAmount) * 100);
            return (
              <div key={idx}>
                <div className="d-flex align-items-center justify-content-between mb-1">
                  <div style={{ minWidth: 0, flex: 1 }}>
                    <p className="fw-semibold mb-0 text-truncate" style={{ fontSize: 13, color: '#1a1a2e' }}>{divName}</p>
                    {primaryName && primaryName !== 'N/A' && (
                      <p className="text-muted mb-0" style={{ fontSize: 11 }}>{primaryName}</p>
                    )}
                  </div>
                  <p className="fw-bold mb-0 ms-3 flex-shrink-0" style={{ fontSize: 13, color: '#1a1a2e' }}>
                    {fmt(Number(amount))}
                  </p>
                </div>
                <div className="rounded-pill overflow-hidden" style={{ height: 4, background: '#f1f5f9' }}>
                  <div style={{ height: '100%', width: `${barPct}%`, background: '#163172', borderRadius: 4, transition: 'width 0.5s' }} />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default TopDivisions;
